<template>
  <div class="search download">
    <div class="search-inner">
      <div class="firstChild">Download</div>

      <div class="genomicLocation">
        <p class="keyword_p1">FTP download</p>
        <el-row style="margin-bottom: 20px;">
          <el-button class="btnSearch" @click="clickJump">Click on</el-button>
        </el-row>
      </div>
      <div class="genomicLocation">
        <p class="keyword_p1">User defined download</p>
        <el-form ref="form2" style="display:flex;" :inline="true" :rules="rules" :model="genomic_form" label-width="auto">
          <el-form-item class="downloadItem1" label="Species" prop="specie">
            <el-select size="large" v-model="genomic_form.specie" @change="speciesChange" placeholder="Choose">
              <el-option v-for="(item, index) in genSpeciesOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="downloadItem2" label-width='70px' label="Type" prop="chromeSome_scaffold">
            <el-select size="large" v-model="genomic_form.chromeSome_scaffold" placeholder="Choose">
              <el-option v-for="(item, index) in genScaffoldOptions" :key="index" :label="item.type" :value="item.type">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item class="downloadItem3">
            <el-input size="large" placeholder="lncRNA locus ID,lncRNA locus accession,keyword" v-model="genomic_form.lncRNA_id"></el-input>
          </el-form-item> -->
        </el-form>
        <el-row style="margin: 20px 0px 40px 0;">
          <el-button class="btnSearch" @click="Search('form2')">
            Download
            <!-- <a :href="DownloadHref" style="color:#fff;"  target="_blank" :download="filename">Download</a> -->
          </el-button>
          <el-button class="btnReset" @click="Reset('form2')">Reset</el-button>
        </el-row>
      </div>
      <div class="genomicLocation">
        <p class="keyword_p1">Genome coordinates in species
          <i class="el-icon-download" @click="downloadSelected"> Download selected</i>
        </p>
        <ul class="bottomUl">
          <li v-for="(item, index) in bottomList" :key="index" :title="item.label">
            <el-checkbox v-model="checked[index]">
              <i @click="clickDonwload(item.filename)">
                {{item.label | ellipsis}}
              </i>
            </el-checkbox>
          </li>
        </ul>
      </div>
      <div class="genomicLocation">
        <p class="keyword_p1">Data Backup
        </p>
        <div class="keyword_p2">
          All of the data above has been uploaded to the Zenodo and can be downloaded by visiting website
          <a href="https://zenodo.org/record/4017591" target="_blank">https://zenodo.org/record/4017591</a>, DOI:10.5281/zenodo.4017591
        </div>
      </div>

    </div>
  </div>
</template>
<script>
let url = {
  location: "species/search_genomic_location",
  specie_all: "species/specie_all/",
  download_type: "species/download_type/",
  download: "user/download",
  download_ftp: "species/download_ftp/"
};
import axios from 'axios';
export default {
  data() {
    return {
      genomic_form: {
        specie: "",
        chromeSome_scaffold: "",
        lncRNA_id: ""
      },
      genSpeciesOptions: [],
      genScaffoldOptions: [
        // { type: 'lncRNA gff' },
        // { type: 'lncRNA transcript sequence' },
        // { type: 'lncRNA secondary structure' },
        // { type: 'lncRNA expression' },
        // { type: 'gene expression' }
      ],
      DownloadHref: '',
      filename: 'ceshi.txt',
      rules: {
        specie: [
          { required: true, message: 'Please select', trigger: 'change' }
        ],
        chromeSome_scaffold: [
          { required: true, message: 'Please select', trigger: 'change' }
        ]
      },
      bottomList: [],
      checked: []
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return ''
      if (value.length > 25) {
        return value.slice(0, 25) + '...'
      }
      return value
    }
  },
  created() {
    this.specie_all();
    // this.download_type()
    this.download_ftp()
  },
  methods: {
    Search(form2) {
      this.$refs[form2].validate((valid) => {
        if (valid) {
          // if (this.genomic_form.chromeSome_scaffold == 'lncRNA gff') {
          //   let specieShortArray = this.genomic_form.specie.split('_')
          //   let specieShort = specieShortArray[0].charAt(0) + '.' + specieShortArray[1].substring(0, 3)
          //   let baseURL = axios.defaults.baseURL.replace('/api', '')
          //   this.DownloadHref = `${baseURL}/ftp/PLncDB_V2.0_tmpdata/lncRNA_gff/${specieShort}.lncRNA.gff3`
          // } else {
          //   this.DownloadHref = `${axios.defaults.baseURL}/${url.download}?specie=${this.genomic_form.specie}&type=${this.genomic_form.chromeSome_scaffold}&lncRNA_id=${this.genomic_form.lncRNA_id}`
          // }
          // const link = document.createElement('a') // 创建a标签          
          // // link.download = 'ceshi6.txt' // a标签添加属性    
          // link.target = '_blank' // a标签添加属性    
          // link.href = this.DownloadHref
          // link.style.display = 'none'
          // // link.href = URL.createObjectURL(blob)          
          // document.body.appendChild(link)
          // link.click() // 执行下载          
          // // URL.revokeObjectURL(link.href) // 释放url          
          // document.body.removeChild(link)

          this.http.get('user/download', {
            species: this.genomic_form.specie,
            type: this.genomic_form.chromeSome_scaffold
          }).then(res => {
            if (res.data.code == 200) {
              window.open(res.data.download_url, '_blank')
            }
          }).catch(err => {
            this.$message.warning(err.data.msg);
          });
        } else {
          return false;
        }
      });
    },
    Reset(form2) {
      this.$refs[form2].resetFields();
    },
    specie_all() {
      this.http.get(url.specie_all, {}).then(res => {
        if (res.data.code == 200) {
          this.genSpeciesOptions = res.data.data;
        }
      }).catch(err => {
        this.$message.warning(err.response.data.error.message);
      });
    },
    download_type(val) {
      this.http.get(url.download_type, { 'species': val }).then(res => {
        if (res.data.code == 200) {
          this.genScaffoldOptions = res.data.data;
        }
      }).catch(err => {
        this.$message.warning(err.data.msg);
      });
    },
    download_ftp() {
      this.http.get(url.download_ftp, {}).then(res => {
        if (res.data.code == 200) {
          this.bottomList = res.data.data;
        }
      }).catch(err => {
        this.$message.warning(err.data.msg);
      });
    },
    clickDonwload(val) {
      var baseURL = axios.defaults.baseURL.replace('/api', '')
      this.DownloadHref = `${baseURL}/zip/${val.substring(0, 5)}.lncRNA.gff.zip`
      // this.DownloadHref = `${baseURL}/ftp/PlncDB_V2.0/lncRNA_gff/${val}`
      const link = document.createElement('a') // 创建a标签   
      link.target = '_blank' // a标签添加属性    
      link.href = this.DownloadHref
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click() // 执行下载                
      document.body.removeChild(link)
    },
    clickJump() {
      // var baseURL = axios.defaults.baseURL.replace('/api', '')
      // window.open(`${baseURL}/ftp/`, '_blank')
      this.$router.push("/ftp");
    },
    downloadSelected() {
      if (this.checked.length < 1) {
        this.$message('Please select the columns to download！')
        return
      }
      this.bottomList.forEach((items, index) => {
        this.checked.forEach((item, idx) => {
          if (index === idx && item === true) {
            this.clickDonwload(items.filename)
          }
        })
      })
    },
    speciesChange(val) {
      this.download_type(val)
    }
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #000;
}
ul,
li {
  list-style: none;
}
.search {
  width: 100%;
  padding: 30px 0px;
  background: #f5f9fc;
}
.search .search-inner {
  width: 1200px;
  padding: 0px 20px;
  margin: 0 auto;
  overflow: hidden;
  background: rgba(255, 255, 255, 1);
}
.search .search-inner .firstChild {
  height: 50px;
  line-height: 50px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  /* line-height: 28px;
  padding-top: 30px; */
  border-bottom: 1px solid rgba(229, 233, 235, 1);
}
.search .search-inner .keyword {
  height: auto;
}
.keyword_p1 {
  margin-top: 30px;
  margin-bottom: 0;
  height: 47px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
.keyword_p2 {
  height: auto;
  font-size: 14px;
  font-family: PingFang SC Regular, PingFang SC Regular-Regular;
  /* font-weight: bold; */
  text-align: justify;
  color: #666666;
  line-height: 28px;
  padding-bottom: 20px;
}
.keyword_p2 a {
  color: #8bb644;
}
.btnSearch {
  width: 126px;
  height: 40px;
  background-color: rgba(139, 182, 68, 1);
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fff;
  outline: none;
  border: none;
}
.btnSearch1 {
  background: rgba(139, 182, 68, 1) url(~@/assets/img/yun.png) no-repeat 10px
    10px;
  padding-left: 50px;
  width: auto;
}
.btnReset {
  width: 126px;
  height: 40px;
  background: #f1f1f1;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333;
  outline: none;
  border: none;
}
.search .search-inner .genomicLocation {
  height: auto;
  /* border-top: 1px solid #d7d9db; */
}

.downloadItem3 {
  width: 100%;
  flex: 1;
}
/* .downloadItem1 {
  width: 300px;
}
.downloadItem2 {
  width: calc(100% - 310px);
  margin-right: 0;
}
.downloadItem2 /deep/ .el-form-item__content {
  width: calc(100% - 71px);
}
.downloadItem2 .el-select {
  width: 100%;
} */
.downloadItem3 /deep/ .el-form-item__content {
  width: 100%;
}
.bottomUl {
  margin: 0;
  width: 100%;
  height: auto;
  overflow: hidden;
  padding: 0;
}
.bottomUl li {
  width: 20%;
  height: 40px;
  float: left;
  font-size: 14px;
  color: #666;
  cursor: pointer;
}
.el-icon-download {
  float: right;
  color: rgb(139, 182, 68);
  font-size: 14px;
  cursor: pointer;
  padding-top: 8px;
  padding-left: 20px;
}
.search >>> .el-checkbox__label {
  color: #666 !important;
}
.download >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.download >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #8bb644;
  border-color: #8bb644;
}
.download >>> .el-checkbox__inner:hover {
  border-color: #8bb644;
}
.download >>> .is-focus .el-checkbox__inner {
  border-color: #8bb644;
}
</style>
